import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import HelpVideosComp from "./Component/HelpVideosComp"


const HelpVideos =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <HelpVideosComp />
        </div>
        <Footer />
        </>
    )
}

export default HelpVideos